import { LoadableAfterPaint } from '@confluence/loadable';

export const ExploreRelatedWork = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ExploreRelatedWorkSidePanel" */ './ui/ExploreRelatedWorkComponent.tsx'
			)
		).ExploreRelatedWorkAndUpdates,
});
